import { queryAll, query, fromId } from '../utils/utils.js';
import instantsearch from 'instantsearch.js';

import algoliasearch from "algoliasearch";
import {
	configure,
	hits,
	pagination,
	searchBox,
	stats,
	currentRefinements,
	clearRefinements,
	refinementList,
	sortBy
} from 'instantsearch.js/es/widgets';
import { connectCurrentRefinements, connectClearRefinements } from 'instantsearch.js/es/connectors';
import { CardCollection } from "../components/card-collection";
import { radiusList } from '../parts/search-radius.js';
import { searchScroll } from '../parts/search-scroll.js';
import { escapeHtml, setAisSearchBoxAriaLabel, setHiddenSortSelectAriaLabel } from './accessibility-helpers.js';

const PROVIDER_SEARCH_ARIA_LABEL = 'Search providers';

const isProviderPlaceholderImage = (url = '') => {
	const haystack = url.toLowerCase();

	return haystack.includes('placeholder-provider-image')
		|| haystack.includes('providerplaceholder')
		|| haystack.includes('providerquoteplaceholder');
};

const getProviderImageDescription = (hit) => {
	const prefix = isProviderPlaceholderImage(hit.image) ? 'Placeholder photo of ' : 'A photograph of ';
	return `${prefix}${hit.title}`;
};

export class ProviderSearch {

	constructor() {

		// this.init();
	}

	init(){
		let doViewAll = false;

		const sortOrder = ['Primary Care', 'Emergency Care/Urgent Care', 'Anesthesiology', 'Hospitalist', 'Surgery', 'Psychiatry', 'Family Medicine'];

		//custom sort order
		const sortType = (a, b) => {
			const indexA = sortOrder.indexOf(a.name);
			const indexB = sortOrder.indexOf(b.name);

			if (indexA !== -1 && indexB !== -1) {
				// Both names are in the ideal order, sort them accordingly
				return indexA - indexB;
			} else if (indexA !== -1) {
				// Only nameA is in the ideal order, it should come first
				return -1;
			} else if (indexB !== -1) {
				// Only nameB is in the ideal order, it should come first
				return 1;
			}

			// If both names are not in the ideal order, sort alphabetically
			if (a.name < b.name) {
				return -1;
			}
			if (a.name > b.name) {
				return 1;
			}
			return 0;
		}

		const search = instantsearch({
			indexName: window.ALGOLIA_INDEX_PREFIX+'providers',
			searchClient: algoliasearch(
			  'LTCGWA12RB',
			  'fbbd5f8b545361104df6b21dfd244cc1'
			),
			routing: true,
			// searchFunction(helper) {
			// 	if (helper.state.query || doViewAll) {
			// 	  helper.search();
			// 	}
			// },
		});

		// ${item.attribute}
		const createDataAttribtues = refinement =>
			Object.keys(refinement)
		  		.map(key => `data-${key}="${refinement[key]}"`)
		  		.join(' ');

		const renderRefinementListItem = ({ item, createURL }) => `
				${item.refinements
					.map(refinement => `<div href="${createURL(refinement)}" class="bhs-link-button primary-btn light ">${refinement.value}&nbsp;<button ${createDataAttribtues(refinement)}><span class="icon icon-exit"></span></button></div>`)
					.join('')}
			`;
			//</a>
		const renderCurrentRefinements = (renderOptions, isFirstRender) => {
			const { items, refine, createURL } = renderOptions;

			const container = document.querySelector('#refinement-list');

			container.innerHTML = `
			  <div class="refinements">
				${items.map(item => renderRefinementListItem({item, createURL})).join('')}
			  </div>
			`;

			let hasTypeFilter = false;
			items.forEach(item => {
				if(item.attribute === "type"){
					hasTypeFilter = true;
				}
			});
			if(hasTypeFilter){
				document.querySelector('.type-chooser-holder').classList.add("hide")
			}else{
				document.querySelector('.type-chooser-holder').classList.remove("hide")
			}


			[...container.querySelectorAll('button')].forEach(element => {
				element.addEventListener('click', event => {
				  const item = Object.keys(event.currentTarget.dataset).reduce(
					(acc, key) => ({
					  ...acc,
					  [key]: event.currentTarget.dataset[key],
					}),
					{}
				  );

				  console.log("clicked", item);
				  refine(item);
				});
			  });
		};

		const customCurrentRefinements = connectCurrentRefinements(
			renderCurrentRefinements
		);

		const renderClearRefinements = (renderOptions, isFirstRender) => {
			const { createURL, canRefine } = renderOptions;

			if (!isFirstRender && canRefine) {
				document.querySelector('#reset-filters').innerHTML = `
					<a href=${createURL()}>Reset Filters</a>
				`;
			}
			if(!canRefine){
				document.querySelector('#reset-filters').innerHTML = ``;
			}
		};

		const customClearRefinements = connectClearRefinements(
			renderClearRefinements
		);

		const renderClearAltRefinements = (renderOptions, isFirstRender) => {
			const { createURL, canRefine } = renderOptions;

			if (!isFirstRender && canRefine) {
				document.querySelector('#reset-type-filter').innerHTML = `
					<div class="item-type item ">
						<a href="${createURL()}" >
							<span>View All Locations</span>
						</a>
					</div>
				`;
			}
			if(!canRefine){
				document.querySelector('#reset-type-filter').innerHTML = ``;
			}
		};

		const customClearAltRefinements = connectClearRefinements(
			renderClearAltRefinements
		);

		search.addWidgets([
			searchBox({
			  container: "#searchbox",
			  placeholder: "Enter provider name, keyword or zip code"

			}),
			configure({
				hitsPerPage: 12,
			}),
			stats({
				container: '#stats',
				templates: {
					text(data, { html }) {
					  if (data.hasManyResults || data.hasOneResult){
						return html`<h4>Search Results (${data.nbHits})</h4>`;
					  }
					  return html`<h4>Search Results (0)</h4>`;
					}
				}
			}),
			stats({
				container: '#bottom-stats',
				templates: {
					text(data, { html }) {
					  if (data.hasManyResults || data.hasOneResult){
						let showing = data.page * data.hitsPerPage;
						if (data.page === 0) {
							if(data.nbHits < data.hitsPerPage){
								showing = data.nbHits;
							}else{
								showing = data.hitsPerPage;
							}
						}else if(data.page >= 1){
							showing = (data.page * data.hitsPerPage+1) + "-" + (data.page * data.hitsPerPage + data.hitsPerPage);
						}
						return html`<p>Showing ${showing}  of ${data.nbHits} results</p>`;
					  }
					  return html``;
					}
				}
			}),
			customCurrentRefinements({
				container: '#refinement-list',
			}),
			//big boxes
			refinementList({
				container: '#type-chooser',
				attribute: 'type',
				operator: 'or',
				sortBy: sortType,
				limit: 7,
				templates: {
					item(item, { html }) {
						const { url, label, count, isRefined } = item;
						let icon = label.toLocaleLowerCase().replaceAll(" ", "-");
						if(icon === "cancer"){
							icon = "dna";
						}
						if(icon === "ear,-nose-and-throat"){
							icon = "pharmacy";
						}
						if(icon === "anesthesia"){
							icon = "anesthesiology";
						}
						if(icon === "emergency-care/urgent-care"){
							icon = "emergency-medicine";
						}
						if(icon === "cardiology"){
							icon = "hospitalist";
						}
						if(icon === "hospital-care"){
							icon = "hospitalist";
						}
						if(icon === "behavioral-health"){
							icon = "psychiatry";
						}
						if(icon === "specialty-care"){
							icon = "specialty";
						}
						if(icon === "patient-services"){
							icon = "patient-services";
						}

						return html`
							<div class="item-type item ${isRefined ? 'checked' : ''}">
								<a href="${url}" >
									<div class="icon icon-${icon}"></div>
									<span>${label}</span>
								</a>
							</div>
						`;
					},
				  },

			}),
			//drop down chooser
			refinementList({
				container: '#specialty-types',
				attribute: 'type',
				operator: 'or',
				limit: 70,
				sortBy: sortOrder,
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;

					  return html`
					  	<li class="checkbox item ${isRefined ? 'checked' : ''}">
							<a href="${url}" >
						  		<span>${label}</span>
							</a>
						</li>
					  `;
					},
				  },

			}),
			radiusList({container: '#location-distance'}),
			refinementList({
				container: '#city',
				attribute: 'city',
				operator: 'or',
				limit: 20,
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;
					  if(label === ","){
						return false;
					  }

					  return html`
					  	<li class="checkbox item ${isRefined ? 'checked' : ''}">
							<a href="${url}" class=" ">
						  		<span>${label}</span>
							</a>
						</li>
					  `;
					},
				  },

			}),

			refinementList({
				container: '#refine-city',
				attribute: 'city',
				operator: 'or',
				limit: 20,
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;
					  if(label === ","){
						return false;
					  }

					  return html`
					  	<li class="checkbox item ${isRefined ? 'checked' : ''}">
							<a href="${url}" class=" ">
						  		<span>${label}</span>
							</a>
						</li>
					  `;
					},
				  },
			}),
			refinementList({
				container: '#refine-specialty',
				attribute: 'type',
				operator: 'or',
				limit: 20,
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;

					  return html`
					  	<li class="checkbox item ${isRefined ? 'checked' : ''}">
							<a href="${url}" class=" ">
						  		<span>${label}</span>
							</a>
						</li>
					  `;
					},
				  },

			}),
			refinementList({
				container: '#refine-location',
				attribute: 'location',
				operator: 'or',
				limit: 20,
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;

					  return html`
					  	<li class="checkbox item ${isRefined ? 'checked' : ''}">
							<a href="${url}" class=" ">
						  		<span>${label}</span>
							</a>
						</li>
					  `;
					},
				  },

			}),
			sortBy({
				container: '#hidden-sort-by',
				items: [
					{ label: 'Sort Alphabetically (A-Z)', value: 'providers_asc' },
					{ label: 'Sort Alphabetically (Z-A)', value: 'providers_desc' },
				],
			}),

			//clear all filters
			customClearRefinements({
				container: '#reset-filters',
			}),
			//clear only the type filter
			// customClearAltRefinements({
			// 	container: '#reset-type-filter',
			// 	attribute: 'type'
			// }),
			hits({
			  container: "#hits",
			  templates: {
				empty(results, { html }) {
					return html`<div class="no-results">No results found for <q>${results.query}</q></div>`;
				},
				item(hit) {
					let specialty = "";
					try{
						specialty = hit.type[0];
					}catch(e){

					}

					let address1 = "";
					let address2 = "";
					let address3 = "";
					try{
						let address_parts = hit.address.split("<br/>");
						address1 = address_parts[0];
						address2 = address_parts[1];
						if(address_parts[2] !== undefined && address_parts[2] !== null && address_parts[2] !== ""){
							address3 = address_parts[2];
						}
					}catch(e){
					}

					const esc = escapeHtml;
					const imageStyle = hit.image != '' ? '' : 'display: none;';
					const locationPlainStyle = hit.location != '' && hit.location_url == '' ? '' : 'display: none;';
					const locationLinkStyle = hit.location != '' && hit.location_url != '' ? '' : 'display: none;';
					const bhsProviderStyle = hit.bhs_provider ? '' : 'display: none;';

					const imageDescription = getProviderImageDescription(hit);

					return `<div class="search-result provider-result card">
							<div class="details">
								<div class="details-top">
									<div>
										<a href="${esc(hit.url)}" class="title">${esc(hit.title)}</a><br/>
										<div class="specialty">${esc(specialty)}</div>
									</div>
									<div class="image">
										<img src="${esc(hit.image)}" alt="${esc(imageDescription)}" title="${esc(imageDescription)}" style="${esc(imageStyle)}" />
									</div>
								</div>
								<div class="details-bottom">
									<div class="topline" style="${esc(locationPlainStyle)}">${esc(hit.location)}</div>
									<div class="topline" style="${esc(locationLinkStyle)}"><a href="${esc(hit.location_url)}">${esc(hit.location)}</a></div>
									<div class="address">
										<div class="address-details">
											${esc(address1)}<br/>${esc(address2)}<br/>${esc(address3)}
											<div class="phone"><a href="tel:${esc(hit.phone)}">${esc(hit.phone)}</a></div>
											<div class="bhs-provider" style="${esc(bhsProviderStyle)}">
												<img src="/wp-content/themes/bhs/assets/images/logo-sm.svg" alt="" /> BHS Provider
											</div>
										</div>
										<div class="address-cta card-cta">
											<a href="${esc(hit.url)}" class="bhs-link-button arrow-link icon-btn light"></a><br/>
										</div>
									</div>
								</div>
							</div>
						</div>`;
					},
				},
			}),
			pagination({
				container: '#pagination',
				padding: 2,
				scrollTo: '#search-results',
			}),
		]);

		search.start();
		setAisSearchBoxAriaLabel('#searchbox', PROVIDER_SEARCH_ARIA_LABEL);
		setHiddenSortSelectAriaLabel();
		let firstRender = true;

		searchScroll();

		search.on('render', () => {
			setAisSearchBoxAriaLabel('#searchbox', PROVIDER_SEARCH_ARIA_LABEL);
			setHiddenSortSelectAriaLabel();
			window.addArrowLinks();

			new CardCollection();


			// hide pagination if there is only one page
			if (search.helper?.lastResults?.nbPages == 1){
				document.querySelector('#pagination').classList.add("hide")
			}else{
				document.querySelector('#pagination').classList.remove("hide")
			}

			if (search.helper?.lastResults?.hits.length === 0){
				document.querySelector('.search-page').classList.add("no-results-found")
			}else{
				document.querySelector('.search-page').classList.remove("no-results-found")
			}

			if(firstRender){
				firstRender = false;
			}

			if (query('.specialty-view-all') === null && query('#type-chooser .ais-RefinementList-list') !== null){
				//append view all to locations type list
				document.querySelector('#type-chooser .ais-RefinementList-list').insertAdjacentHTML('beforeend', `
				<li class="ais-RefinementList-item">
					<div>
						<div class="item-type item specialty-view-all">
							<a href="#" >
								<span>View All Specialty</span>
							</a>
						</div>
					</div>
				</li>
				`);

				query('.specialty-view-all a').addEventListener('click', (event) => {
					event.preventDefault();
					doViewAll = true;
					search.setUiState((uiState) => ({
						...uiState,
						[window.ALGOLIA_INDEX_PREFIX+"providers"]: {
							...uiState[window.ALGOLIA_INDEX_PREFIX+"providers"],
							page: 1,
							refinementList: {
								...uiState[window.ALGOLIA_INDEX_PREFIX+"providers"].refinementList,
								type: [],
							}
						},
					}));
				});

			}

			//conditionally hide filters
			if(search.renderState.locations?.refinementList?.c_type?.items?.length < 1){
				document.querySelector('.dropdown-c-type').classList.add("hide")
			}else{
				document.querySelector('.dropdown-c-type').classList.remove("hide")
			}
			if(search.renderState.locations?.refinementList?.p_type?.items?.length < 1){
				document.querySelector('.dropdown-p-type').classList.add("hide")
			}else{
				document.querySelector('.dropdown-p-type').classList.remove("hide")
			}
			if(search.renderState.locations?.refinementList?.city?.items?.length < 1){
				document.querySelector('.dropdown-city').classList.add("hide")
			}else{
				document.querySelector('.dropdown-city').classList.remove("hide")
			}

			if(search.renderState.locations?.refinementList?.type?.items?.length < 1){
				// doViewAll = true;
			}

			// make search results clickable
			queryAll('.ais-Hits-list .ais-Hits-item .card').forEach((card) => {
				const button = card.querySelector('.bhs-link-button');
				card.querySelectorAll('a').forEach((a) => {

					if (!a.classList.contains('bhs-link-button')) {
						a.addEventListener('click', (e) => {
							e.stopPropagation();
						});
					}

				});

				if (button) {
					card.addEventListener('click', (e) => {
						button.click();
					});
					card.addEventListener('mouseover', (e) => {
						button.classList.add('hover');
					});
					card.addEventListener('mouseout', (e) => {
						button.classList.remove('hover');
					});
				}
			});

			//search.renderState.locations?.hits?.hits?.length >= 1
			// console.log(search.renderState.locations?.searchBox?.query, doViewAll);
			// if(doViewAll || search.renderState.locations?.searchBox?.query !== ""){
			// 	document.querySelector('.search-results-holder').classList.remove("hide")
			// }
		});

		if (query('#sort-by') !== null) {
			console.log("here");
			const sortLinks = document.querySelectorAll('#sort-by a');
			sortLinks.forEach((link) => {
				link.addEventListener('click', (event) => {
					event.preventDefault();
					link.parentNode.parentNode.querySelectorAll('.checked').forEach(el => el.classList.remove('checked'));
					link.parentNode.classList.add('checked');

					const select = document.querySelector('#hidden-sort-by select');
					const value = link.getAttribute("href").replace("#", "");
					for (let i = 0; i < select.options.length; i++) {
						if (select.options[i].value === value) {
							select.selectedIndex = i;
							break;
						}
					}
					select.dispatchEvent(new Event('change'));
				});
			});
		}

	}



}
